// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2fcuR","left":"InfoRow_left__3jDGl"};